import * as React from 'react';
import {type Matcher, type PropsBase, type PropsSingle} from 'react-day-picker';
import {Calendar} from '../../../calendar';

type SingleDateCalendarProps = Omit<
  Partial<PropsSingle>,
  'mode' | 'selected' | 'onSelect'
> &
  Omit<PropsBase, 'mode' | 'selected' | 'disabled'> & {
    value: Date | undefined;
    month: Date;
    onMonthChange: (month: Date) => void;
    onSelect: NonNullable<PropsSingle['onSelect']>;
    numberOfMonths: number;
    minDate?: Date;
    maxDate?: Date;
    autoFocus?: boolean;
    disabledMatchers: Matcher[];
    components?: PropsBase['components'];
  };

export function SingleDateCalendar({
  value,
  month,
  onMonthChange,
  onSelect,
  numberOfMonths,
  minDate,
  maxDate,
  autoFocus,
  disabledMatchers,
  components,
  ...dayPickerProps
}: SingleDateCalendarProps) {
  return (
    <Calendar
      mode="single"
      selected={value}
      month={month}
      onMonthChange={onMonthChange}
      onSelect={onSelect}
      numberOfMonths={numberOfMonths}
      startMonth={minDate}
      endMonth={maxDate}
      autoFocus={autoFocus}
      disabled={disabledMatchers}
      components={components}
      className="p-5"
      {...dayPickerProps}
    />
  );
}
